export default "/images/9c49c06d37eaa00801f0d3ecca3fc758.avif";